import { LargeTitle, makeStyles, Skeleton, SkeletonItem, Text } from "@fluentui/react-components"
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    title: {
        color: "white",
        textAlign: "center",
        marginBottom: "1rem",
    },
    description: {
        color: "white",
        textAlign: "center",
        maxWidth: "800px",
    },
    skeletons: {
        display: "grid",
        gap: "1rem",
        margin: "2rem",
    },
    skeleton: {
        height: "10vh"
    }
});

export default function Placeholder() {
    const { t } = useTranslation("general");
    const styles = useStyles();

    return (
        <div id="placeholder">
            <main>
                <div>
                    <section className="hero">
                        <div className="hero-overlay" />
                        <div className="image-container">
                            <LargeTitle block as="h1" className={styles.title}>
                                {t("companyName")}
                            </LargeTitle>
                            <Text block as="h3" className={styles.description} size={500}>
                                {t("loading")}
                            </Text>
                        </div>
                    </section>

                    <section>
                        <div className={styles.skeletons}>
                            <Skeleton className={styles.skeleton}>
                                <SkeletonItem shape="rectangle" className={styles.skeleton} />
                            </Skeleton>
                            <Skeleton className={styles.skeleton}>
                                <SkeletonItem shape="rectangle" className={styles.skeleton} />
                            </Skeleton>
                            <Skeleton className={styles.skeleton}>
                                <SkeletonItem shape="rectangle" className={styles.skeleton} />
                            </Skeleton>
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
}